import type { ReactNode } from 'react';
import { UserButton } from '@clerk/react';
import { BRAND_NAME } from '../config/brand';
import { useCommerce } from '../account/commerce';
import { LocalStudioEntry } from './LocalStudioEntry';
import './public.css';

export function AccountControl() {
  const commerce = useCommerce();
  if (commerce?.status === 'local') return null;
  if (commerce?.status === 'ready') return commerce.config?.clerkPublishableKey ? <UserButton /> : <a href="/auth/logout">Sign out</a>;
  return <a href="/sign-in?returnTo=%2Fstudio">Log in</a>;
}
export function PublicShell({ children }: { children: ReactNode }) {
  const commerce = useCommerce();
  const local = commerce?.status === 'local';
  return <div className="public-site"><header className="site-header"><a className="site-wordmark" href="/">{BRAND_NAME}</a><nav aria-label="Main navigation">
    <a href="/#features">Features</a><a href="/samples">Previews</a><a href="/pricing">Pricing</a>
    {(local || commerce?.status === 'ready') && <a href="/studio">Open studio</a>}
    {commerce?.status === 'ready' && <a href="/account">Account</a>}<AccountControl />
    {!local && commerce?.status !== 'ready' && <a className="site-button site-header-signup" href="/sign-up?returnTo=%2Fstudio">Sign up</a>}
  </nav></header><LocalStudioEntry /><main className="site-content">{children}</main><SiteFooter /></div>;
}
export function SiteFooter() {
  return <footer className="site-footer"><span>{BRAND_NAME}</span><nav aria-label="Policies"><a href="/pricing">Pricing</a><a href="/privacy">Privacy Policy</a><a href="/terms">Terms of Use</a></nav></footer>;
}
